import { useContext } from 'react'
import { useMutation } from 'react-query'
import { apiPatch } from 'api'
import AuthContext from 'context/auth-context'

const updateMunicipalityAnalytic = async (token, params) => {
  const objectName = 'municipality_analytic'
  const url = `municipality_analytics/${params.id}`

  return apiPatch({ url, token, objectName, params })
}

// Hook accepts options only; params are passed when calling mutate()
export function useUpdateMunicipalityAnalytic({ options } = {}) {
  const token = useContext(AuthContext)

  return useMutation((params) => {
    return updateMunicipalityAnalytic(token, params)
  }, { ...options })
}
